import FlumpObject from "../../general/objects/FlumpObject";
import * as GameModel from "../../models/GameModel";
import { audioPlayer } from "../../PhaserExtension";
import FlumpButton from "../../general/objects/FlumpButton";

export default class Cutscene extends Phaser.Sprite
{
    constructor(game, config, x, y, key, frame)
    {
        super(game, x, y, key, frame);
        this.config = config;
        this.onCutsceneComplete = new Phaser.Signal();
    }

    setupCutscene()
    {
        this.grover = new FlumpObject(this.game, this.config.grover, "groverFlump");
        this.addChild(this.grover);

        if(GameModel.data.storiesPlayed > 0)
        {
            this.grover.loop(this.grover.keys.noBallIdle);
        }
        else
        {
            this.grover.loop(this.grover.keys.idle);
        }

        this.language = GameModel.data.english ? "_eng" : "_esp";
        this.players = GameModel.data.isTwoPlayer ? "_2p" : "_1p";
        this.greetIndex = 0;
        this.skipped = false;

        this.skipButton = new FlumpButton(this.game, this.config.skipButton, "mainFlump");
    }

    update()
    {
        this.grover.update();
    }

    playCutscene(muppets, skipButtonLayer, ball, state)
    {
        if(GameModel.data.storiesPlayed > 0)
        {
            let index = this.game.rnd.between(1, 3);
            this.grover.playOnce(this.grover.keys["subseqIntro" + index + this.language], true, true);
            audioPlayer.play(this.game, this.config.sounds["subseqIntro" + index]);
            this.grover.onComplete.addOnce(this._subseqEnd, this);
        }
        else
        {
            this.muppets = [];
            this.muppets.push(muppets[2]);
            this.muppets.push(muppets[0]);
            this.muppets.push(muppets[1]);

            this.grover.playOnce(this.grover.keys["intro1" + this.language], true, true);
            audioPlayer.play(this.game, this.config.sounds.intro1);
            this.grover.onComplete.addOnce(this._playGreetings, this);
        }

        skipButtonLayer.addChild(this.skipButton);
        this.skipButton.onClicked.addOnce(this._skipCutscene, this);

        this.ball = ball;
        this.state = state;
    }

    _playGreetings()
    {
        if(this.skipped) return;
        if(this.greetIndex == this.muppets.length)
        {
            this._greetingsComplete();
            return;
        }
        this.grover.playOnce(this.grover.keys["intro" + (2 + this.greetIndex) + this.language + (this.greetIndex == 2 ? this.players : "")], true, true);
        this.muppets[this.greetIndex].greet();
        audioPlayer.play(this.game, this.config.sounds.greetings[this.greetIndex][this.players], this._playGreetings, this);
        this.greetIndex++;
    }

    _greetingsComplete()
    {
        if(this.skipped) return;
        this.grover.playOnce(this.grover.keys["intro5" + this.language], false, true);
        this.grover.onComplete.addOnce(this._passBall, this);
        audioPlayer.play(this.game, this.config.sounds.intro2);
    }

    _passBall()
    {
        if(this.skipped) return;
        this.grover.playOnce(this.grover.keys["intro6" + this.language], false, true);
        this.grover.onComplete.addOnce(this._passBallBack, this);
        // pass ball to elmo
        this.ball.x = 840;
        this.ball.y = 900;
        this.ball.tweenTo(950, 490);
        this.ball.onTweenComplete.addOnce(this.onElmoReceivedBall, this);
    }

    onElmoReceivedBall()
    {
        if(this.skipped) return;
        this.ball.visible = false;
        this.muppets[0].receiveBallInCutscene();
    }

    _passBallBack()
    {
        if(this.skipped) return;
        this.muppets[0].passBall(this._onElmoPass, this);
    }

    _onElmoPass()
    {
        if(this.skipped) return;
        this.ball.tweenTo(GameModel.data.isTwoPlayer ? this.ball.config.transform.playerOnePosition : this.ball.config.transform.position);
        this.ball.onTweenComplete.addOnce(this._end, this);
    }

    _subseqEnd()
    {
        if(this.skipped) return;
        this.skipButton.visible = false;
        this.state.player.loop(this.state.player.keys.holdBall);
        this.state.player.playOnce(this.state.player.keys.holdBallEnter, true);
        this.grover.visible = false;
        this.state.player.onComplete.addOnce(this._completeCutscene, this);
    }

    _end()
    {
        if(this.skipped) return;
        this.skipButton.visible = false;
        this.state.player.loop(this.state.player.keys.holdBall);
        this.state.player.playOnce(this.state.player.keys.holdBallEnter, true);
        audioPlayer.play(this.game, this.config.sounds["end" + this.players], this._completeCutscene, this);
    }

    _skipCutscene()
    {
        this.skipped = true;
        this.skipButton.visible = false;

        GameModel.data.transition.visible = true;
        GameModel.data.transition.playOnce("transition_start", false, true);
        GameModel.data.transition.onComplete.addOnce(this._transitionIn, this);
        audioPlayer.play(this.game, { playbackType: "normal", trackKey: [ "wipe" ] });
        this.game.input.enabled = false;
        this.grover.onComplete.removeAll(this);
        this.ball.onTweenComplete.removeAll(this);
    }

    _transitionIn()
    {
        this.grover.visible = false;
        audioPlayer.stopChannel("VO", false);
        this.state.player.loop(this.state.player.keys.holdBall);
        GameModel.data.transition.playOnce("transition_end", false, true);
        GameModel.data.transition.onComplete.addOnce(this._completeCutscene, this);
        audioPlayer.play(this.game, { playbackType: "normal", trackKey: [ "wipe" ] });
        this.game.input.enabled = true;
    }

    _completeCutscene()
    {
        GameModel.data.transition.visible = false;
        audioPlayer.stopChannel("VO", false);
        this.onCutsceneComplete.dispatch();
        this.skipButton.kill();
    }

    destroy()
    {
        this.grover.destroy(true);
        delete this.grover;
        delete this.muppets;
        this.onCutsceneComplete.dispose();
        this.skipButton.destroy(true);
        delete this.skipButton;
        delete this.ball;
        delete this.state;
        super.destroy();
    }
}
